import { Box } from "@mui/material";

export const CalenderButtonGroup = ({ sx, children }) => {
  return (
    <Box
      sx={(theme) => ({
        borderRadius: "17.5px",
        outline: `1px solid ${theme.palette.action.disabled}`,
        display: "flex",
        alignItems: "center",
        height: "31px",
        p: "2px",
        "&:hover": { outline: `1px solid ${theme.palette.text.primary}` },
        ...sx,
      })}
    >
      {children}
    </Box>
  );
};
